var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 17.3333L26.1147 17.3333L19.0573 24.3907C18.93 24.5137 18.8284 24.6608 18.7585 24.8235C18.6887 24.9861 18.6519 25.1611 18.6503 25.3381C18.6488 25.5152 18.6825 25.6907 18.7496 25.8546C18.8166 26.0185 18.9156 26.1673 19.0408 26.2925C19.166 26.4177 19.3149 26.5167 19.4787 26.5838C19.6426 26.6508 19.8182 26.6845 19.9952 26.683C20.1722 26.6815 20.3472 26.6447 20.5099 26.5748C20.6725 26.5049 20.8197 26.4033 20.9427 26.276L30.276 16.9427C30.526 16.6926 30.6664 16.3535 30.6664 16C30.6664 15.6464 30.526 15.3074 30.276 15.0573L20.9427 5.72399C20.6912 5.48112 20.3544 5.34672 20.0048 5.34976C19.6552 5.3528 19.3208 5.49303 19.0736 5.74024C18.8264 5.98745 18.6861 6.32186 18.6831 6.67146C18.6801 7.02106 18.8145 7.35786 19.0573 7.60933L26.1147 14.6667L2.66666 14.6667C2.31304 14.6667 1.9739 14.8071 1.72385 15.0572C1.4738 15.3072 1.33333 15.6464 1.33333 16C1.33333 16.3536 1.4738 16.6928 1.72385 16.9428C1.9739 17.1929 2.31304 17.3333 2.66666 17.3333Z",
    fill: "#3E64F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.ae20ee9687e03836e02f8fa19ccc6592.svg";
export { ForwardRef as ReactComponent };